import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { ReportTemplateTypeEnum } from '../enums/report-template-type.enum';

/**
 * Report templates filters
 */
export class ReportTemplatesFilters extends ApiRequestFilters {
	/**
	 * Report template type values
	 */
	types?: ReportTemplateTypeEnum[];

	/**
	 * Tag id values
	 */
	tags?: number[];
}
